'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')
var Tabs = require('src/behaviors/tabs')

var DialogModel = require('src/common/dialog-model.js')

var EditNewView = require('./view.js')
var EditNewController = require('src/components/edit_new-controller.js')

var EditNewApiKey = function (options) {
  var Controller = EditNewController.extend({
    initialize: function (options) {
      this.region = options.region

      // var tabs = new Tabs.Collection([
      //   (new Tabs.Model({ label: 'Basic', slug: 'basic', elementId: 'tab-basic' })),
      //   (new Tabs.Model({ label: 'Notifications', slug: 'notifications', elementId: 'tab-notifications' }))
      // ])

      var apiKeys = options.collection
      var apiKey = options.model

      if (!apiKey) apiKey = App.globalChannel.request('apikey:entity:new')

      // define the dialog model
      var dialogModel = new DialogModel({
        title: 'Key',
        buttons: {
          left: [
            { label: 'delete', icon: true, slug: 'delete', action: 'dialog:delete', roles: ['super', 'admin'] }
          ],
          right: [
            { label: 'cancel', slug: 'cancel', action: 'dialog:close', roles: ['super', 'admin'] },
            { label: 'save', primary: true, slug: 'save', action: 'dialog:submit', roles: ['super', 'admin'] }
          ]
        }
      })

      // load view
      this.view = this.getLayout(dialogModel, apiKey, apiKeys)

      // listen
      this.listenTo(this.view, 'dialog:submit', this.formSubmit)
      this.listenTo(this.view, 'dialog:delete', this.onDelete)
      this.listenTo(this.view, 'childview:send-new-password', this.onSendNewPassword)

      this.region.show(this.view)
    },
    formPreSave: function (model, data) {
      var self = this

      if (model.isNew()) data.client = self.options.client.get('_id')

      return data
    },
    /* Event methods --------------------------------------------------------- */
    onDeleteMessage: function (model, message) {
      return 'Are you sure you want to delete the key "' + model.get('name') + '"?'
    },
    /* Views ----------------------------------------------------------------- */
    getLayout: function (dialogModel, model, collection) {
      return new EditNewView.Layout({
        dialogModel: dialogModel,
        model: model,
        collection: collection
      })
    }
  })

  return new Controller(options)
}

module.exports = EditNewApiKey



// WEBPACK FOOTER //
// ./js/modules/client-apikeys/edit_new/index.js